/**
 * バリデーション分類コード × 書体 × 和文(ja)/英文(en) の最大文字数。
 * ja: 0 は日本語不可（英字専用書体）。
 */
export const MAX_LENGTH_BY_CODE_AND_FONT = {
  engraving_2font_12letter_na: {
    "楷書体★": { ja: 6, en: 12 },
    "英字【筆記体】(頭文字大文字)": { ja: 0, en: 12 },
  },
  engraving_3font_15letter_na: {
    "楷書体★": { ja: 11, en: 15 },
    "ゴシック体★": { ja: 11, en: 15 },
    "英字【ローマン体】(頭文字大文字)": { ja: 0, en: 15 },
  },
  engraving_3font_22letter_na: {
    "楷書体★": { ja: 18, en: 22 },
    "ゴシック体★": { ja: 18, en: 22 },
    "英字【ローマン体】(頭文字大文字)": { ja: 0, en: 22 },
  },
  engraving_6font_3letter_na: {
    "楷書体★": { ja: 0, en: 3 },
    "行書体★": { ja: 0, en: 3 },
    "ゴシック体★": { ja: 0, en: 3 },
    "英字【筆記体】(頭文字大文字)": { ja: 0, en: 3 },
    "英字【太 筆記体】(頭文字大文字)": { ja: 0, en: 3 },
    "英字【ローマン体】(頭文字大文字)": { ja: 0, en: 3 },
  },
  engraving_6font_12letter_na: {
    "楷書体★": { ja: 6, en: 12 },
    "行書体★": { ja: 6, en: 12 },
    "ゴシック体★": { ja: 6, en: 12 },
    "英字【筆記体】(頭文字大文字)": { ja: 0, en: 12 },
    "英字【太 筆記体】(頭文字大文字)": { ja: 0, en: 12 },
    "英字【ローマン体】(頭文字大文字)": { ja: 0, en: 12 },
  },
  engraving_6font_15letter_na: {
    "楷書体★": { ja: 11, en: 15 },
    "行書体★": { ja: 11, en: 15 },
    "ゴシック体★": { ja: 11, en: 15 },
    "英字【筆記体】(頭文字大文字)": { ja: 0, en: 15 },
    "英字【太 筆記体】(頭文字大文字)": { ja: 0, en: 15 },
    "英字【ローマン体】(頭文字大文字)": { ja: 0, en: 15 },
  },
  engraving_6font_22letter_na: {
    "楷書体★": { ja: 18, en: 22 },
    "行書体★": { ja: 18, en: 22 },
    "ゴシック体★": { ja: 18, en: 22 },
    "英字【筆記体】(頭文字大文字)": { ja: 0, en: 22 },
    "英字【太 筆記体】(頭文字大文字)": { ja: 0, en: 22 },
    "英字【ローマン体】(頭文字大文字)": { ja: 0, en: 22 },
  },
  engraving_2font_22letter_na2: {
    "楷書体★": { ja: 14, en: 22 },
    "ゴシック体★": { ja: 14, en: 22 },
  },
  engraving_2font_40letter_na2: {
    "楷書体★": { ja: 24, en: 40 },
    "ゴシック体★": { ja: 24, en: 40 },
  },
  engraving_11font_15letter_na: {
    "楷書体★": { ja: 11, en: 15 },
    "行書体★": { ja: 11, en: 15 },
    "ゴシック体★": { ja: 11, en: 15 },
    "英字【筆記体】(頭文字大文字)": { ja: 0, en: 15 },
    "英字【太 筆記体】(頭文字大文字)": { ja: 0, en: 15 },
    "英字【ローマン体】(頭文字大文字)": { ja: 0, en: 15 },
    "すず体★": { ja: 11, en: 15 },
    "ペン文字★": { ja: 11, en: 15 },
    "英字【ラブリー体】(頭文字大文字)": { ja: 0, en: 15 },
    "英字【エレガント体】(頭文字大文字)": { ja: 0, en: 15 },
    "英字【ポップ体】(頭文字大文字)": { ja: 0, en: 15 },
  },
  engraving_11font_22letter_na: {
    "楷書体★": { ja: 18, en: 22 },
    "行書体★": { ja: 18, en: 22 },
    "ゴシック体★": { ja: 18, en: 22 },
    "英字【筆記体】(頭文字大文字)": { ja: 0, en: 22 },
    "英字【太 筆記体】(頭文字大文字)": { ja: 0, en: 22 },
    "英字【ローマン体】(頭文字大文字)": { ja: 0, en: 22 },
    "すず体★": { ja: 18, en: 22 },
    "ペン文字★": { ja: 18, en: 22 },
    "英字【ラブリー体】(頭文字大文字)": { ja: 0, en: 22 },
    "英字【エレガント体】(頭文字大文字)": { ja: 0, en: 22 },
    "英字【ポップ体】(頭文字大文字)": { ja: 0, en: 22 },
  },
} as const;
